<template>
    <v-container>
        <h1 class="titulo mb-5">PROCESSO DE SINCRONIZAÇÃO DE PROPOSTAS</h1>
        <h3 class="mb-6">Configuração do processo automático</h3>
        <v-form ref="formConfigAgendamento" @submit.prevent="salvarConfiguracao">
            <v-row>
                <v-col cols="12" md="7">
                    <v-row class="mt-4 align-center">
                        <v-col cols="12" md="9" lg="6">
                            <v-text-field
                                    label="Horários para execução do processo"
                                    id="horariosProcesso"
                                    placeholder="Ex: 08:30, 12:00, 18:00"
                                    name="horariosProcesso"
                                    :class="{'required': habilitarFuncionalidade}"
                                    :rules="[habilitarFuncionalidade ? $rules.required : true]"
                                    outlined
                                    autocomplete="off"
                                    v-model="inputHorarios"
                            />
                        </v-col>
                        <v-col cols="12" md="9" lg="6" class="mb-6 mb-lg-0">
                            <ToggleButton
                                    class="pt-2 mr-2"
                                    v-model="habilitarFuncionalidade"
                                    :sync="true"
                                    :labels="false"
                                    color="var(--primary)"
                            ></ToggleButton>
                            <span class="text--dark">Desabilitar\Habilitar</span>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="5">
                    <HintMessage
                            class="mt-8 mb-5"
                            title="DICA PARA CONFIGURAÇÃO"
                            icon="mdi-lightbulb-on-outline"
                            icon-color="secondary"
                            :description="SincronizacaoPropostasTipMessage"
                            :description-html="true"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col class="justify-end d-flex" offset="10" cols="2">
                    <v-btn class="mt-3" color="primary" rounded @click="salvarConfiguracao">
                        Salvar
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <v-divider class="mt-6"></v-divider>
        <ExecucaoManualSyncPropostas />
    </v-container>
</template>
<script>
  import { ToggleButton } from 'vue-js-toggle-button'
  import { SincronizacaoPropostasTipMessage } from '../../enums/HintMessages/tipMessage'
  import ExecucaoManualSyncPropostas from './SincronicazoesPropostas/ExecucaoManualSyncPropostas.vue'
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../../plugins/alerts_types'
  import { ComandosDoSchedule } from '../../enums/agendamentos_schedule/commands'

  export default {
    name: 'SincronizacaoPropostas',
    components: { ToggleButton, ExecucaoManualSyncPropostas },
    data: () => ({
      SincronizacaoPropostasTipMessage,
      inputHorarios: '',
      habilitarFuncionalidade: false
    }),
    watch: {
      habilitarFuncionalidade () {
        this.$refs.formConfigAgendamento.resetValidation()
      }
    },
    mounted () {
      this.getConfiguracaoPropostas()
    },
    methods: {
      async salvarConfiguracao () {
        if (!this.$refs.formConfigAgendamento.validate()) {
          return
        }
        let agendamentos = []
        if (this.habilitarFuncionalidade && !this.inputHorarios) {
          notification(AlertTypes.WARN, 'Informe ao menos um horário para salvar habilitado!')
          return
        }
        let horarios = this.inputHorarios.split(',').map(h => h.trim()).filter(h => h.length > 0)
        const regexHorario = /^([01]\d|2[0-3]):([0-5]\d)$/
        for (const horario of horarios) {
          if (!regexHorario.test(horario)) {
            notification(AlertTypes.WARN, `Formato de horário inválido: ${horario}. Utilize o padrão HH:MM.`)
            return
          }
          agendamentos.push({ hora_agendada: horario })
        }
        const payload = {
          comando: ComandosDoSchedule.propostasResumida,
          ativo: this.habilitarFuncionalidade,
          agendamentos: agendamentos
        }
        this.$http.post('painel/agendamentos/substuituir_agendamento_comando', payload)
          .then((response) => {
            notification(AlertTypes.SUCCESS, response.data.message)
          })
          .catch((error) => {
            notification(AlertTypes.ERROR, error)
          })
      },
      async getConfiguracaoPropostas () {
        return this.$http.get('painel/agendamentos/obter_configuracao_agendamento', { params: { 'comando': ComandosDoSchedule.propostasResumida } })
          .then(({ data }) => {
            if (data.agendamentos && data.agendamentos.length > 0) {
              const horarios = data.agendamentos.map(a => a.hora_agendada.substring(0, 5)).join(', ')
              this.inputHorarios = horarios
              this.habilitarFuncionalidade = data.agendamentos.some(a => a.ativo)
            } else {
              this.habilitarFuncionalidade = false
            }
          })
      }
    }
  }
</script>
